import React from 'react';
import { useIntl } from 'ha/i18n';
import { languages as Languages } from 'ha/constants/SpokenLanguages';

import { Wrapper } from './Wrapper';
import { Variant } from './types';

const UserCardSpokenLanguages: React.FC<{
  spokenLanguages: string[];
  variant: Variant;
}> = ({ spokenLanguages, variant }) => {
  const { T } = useIntl();

  return (
    <Wrapper variant={variant} dataTestLocator="User Card SpokenLanguages">
      {`${T('Speaks')} ${spokenLanguages
        .map(langCode => T(Languages[langCode]))
        .join(', ')}`}
    </Wrapper>
  );
};

export { UserCardSpokenLanguages };
